module.exports = __webpack_public_path__ + "6a1e950d14904d4b6fb5c9bdc3dfad06.png";